import React from "react";
import { Linkedin, Mail, ArrowUp } from "lucide-react";
import { Wordmark } from "./Logo";
import { scrollToTop } from "../../lib/ui-motion";
import { useLang, CONTACT } from "../../i18n";

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  const year = new Date().getFullYear();

  const links = [
    { icon: Linkedin, label: "LinkedIn", href: CONTACT.linkedin },
    { icon: Mail, label: "Email", href: `mailto:${CONTACT.email}` },
  ];

  return (
    <footer className="relative border-t border-white/10 py-14" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
          <div className="max-w-sm">
            <Wordmark />
            <p className="mt-4 text-sm text-white/45 leading-relaxed">{f.tagline}</p>
          </div>

          <div className="flex flex-col items-start md:items-end gap-5">
            <div className="flex gap-3">
              {links.map((l) => (
                <a key={l.label} href={l.href} target="_blank" rel="noopener noreferrer"
                  data-cursor="hover" data-testid={`footer-${l.label.toLowerCase()}`}
                  className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-white/60 hover:bg-flame hover:text-black hover:border-flame transition-colors">
                  <l.icon size={18} />
                </a>
              ))}
              <button onClick={scrollToTop} data-cursor="hover" data-testid="footer-top"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-white/60 hover:bg-flame hover:text-black hover:border-flame transition-colors" aria-label="Back to top">
                <ArrowUp size={18} />
              </button>
            </div>
            <a href={`https://${CONTACT.domain}`} className="font-heading font-semibold text-white/70 hover:text-flame transition-colors">{CONTACT.domain}</a>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-white/5 pt-6 text-xs text-white/35">
          <span>© {year} Rui Guimarães. {f.rights}</span>
          <span>{f.built}</span>
        </div>
      </div>
    </footer>
  );
};
